import { Routes } from '../Routes';

export const Main = () => {
  return (
    <main className="app-main column is-vertical py-5 px-6">
      <Routes />
    </main>
  );
};
